import React, { Component } from "react";
/**
 * 
 */
class Equivalencias extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     * @param {any} event
     */
    onEquivalenciaChange(event) {
        const { value } = event.target;
        const { idequivalenciainstancia } = event.target.dataset;

        this.props.actualizarEquivalencia(idequivalenciainstancia, value);
    }
    /**
     * 
     * @param {any} event
     */
     onSubEquivalenciaChange(event) {
        const { value } = event.target;
        const { idequivalenciainstancia } = event.target.dataset;

        let codigoSubequivalencia = this.props.data.subEquivalencias.filter( x => x.Id == value)[0]?.Codigo;

        this.props.actualizarSubEquivalencia(idequivalenciainstancia, value, codigoSubequivalencia);
    }
    /**
     * 
     * @param {any} event
     */
    onInputEquivalenciaChange(event) {
        const { value } = event.target;
        const { idequivalenciainstancia } = event.target.dataset;

        this.props.actualizarEquivalencia(idequivalenciainstancia, undefined, value);
    }

    /**
     * 
     */
    render() {
        const { eliminarEquivalencia, data } = this.props;
        const { equivalencias, subEquivalencias } = data;
        let permiteEquivalencia = data.requiereEquivalencia;
        let requiereSubequivalencia = data.requiereSubequivalencia;

        const instanciaEquivalencias = data.instanciaEquivalencias.filter((equi0) => !equi0.DeleteInstance).map((equi, index) => {
            let codigoEquivalenciaSeleccionada = equivalencias.filter((eq) => { return eq.Id == equi.IdEquivalencia})[0]?.Codigo;
            let subequivalenciasSinEquivalencias = subEquivalencias.filter(sub => !sub.EquivalenciaId);
            let subequivalenciasConEquivalencias = subEquivalencias.filter(sub => sub.EquivalenciaId == equi.IdEquivalencia);
            let arraySubequivalencias = subequivalenciasConEquivalencias.length > 0 ? [...subequivalenciasSinEquivalencias, ...subequivalenciasConEquivalencias] : subequivalenciasSinEquivalencias;

            const equivalenciasNodes = equivalencias.map((row, index) => {
                return <option value={row.Id} key={"equivalenciaItem_" + index} >{row.Codigo}</option>
            });

            const subEquivalenciasNodes = arraySubequivalencias.map((row, index) => {
                return <option value={row.Id} key={"subEquivalenciaItem_" + index} >{row.Codigo}</option>
            });

            const jumboClase = "col-md-10 jumbodiv bottom-separator-xs" + ((equi.huboError == true) ? " NuevaInstanciaParametro-alert-danger" : "");

            return (
                <div key={equi.IdEquivalenciaInstancia} className={jumboClase}>
                    <div className="btn-equivalencia-cross btnEquivalenciaAtlas" onClick={() => { eliminarEquivalencia(equi.IdEquivalenciaInstancia) }}>
                        <span id="eliminarItemEquivalencia" className="btn-x-top-right clickable" ><i className="ti-close"></i></span>
                    </div>

                    <div className="row top-separator-xs containerEquivalenciaAtlas">
                        <div className="col-xs-6">
                            <div>
                                <label className="label-primary">Equivalencia</label>
                            </div>
                            <div>
                                <select onChange={this.onEquivalenciaChange.bind(this)} className="form-control bottom-separator-xs" value={equi.IdEquivalencia}
                                    data-idequivalenciainstancia={equi.IdEquivalenciaInstancia}>
                                    <option value="0">Seleccione...</option>
                                    {equivalenciasNodes}
                                </select>
                            </div>
                        </div>

                        {requiereSubequivalencia ?
                            <div className="col-xs-6">
                                <div>
                                    <label className="label-primary">Sub-Equivalencia</label>
                                </div>
                                <div>
                                    <select onChange={this.onSubEquivalenciaChange.bind(this)} className="form-control bottom-separator-xs" value={equi.SubequivalenciaId}
                                        data-idequivalenciainstancia={equi.IdEquivalenciaInstancia}>
                                        {subEquivalenciasNodes}
                                    </select>
                                </div>
                            </div>
                        :
                            null
                        }

                        <div className="col-xs-6">
                            <div>
                                <label className="label-primary">Código</label>
                            </div>
                            <div>
                                <input value={equi.ValorEquivalencia} className="form-control" data-idequivalenciainstancia={equi.IdEquivalenciaInstancia}
                                    onChange={this.onInputEquivalenciaChange.bind(this)} maxLength="50" />
                            </div>
                        </div>

                        {/* Visualización de labels de Error */}
                        {equi.huboError && 
                            <div className="col-xs-12">
                                <label className="error NuevaInstanciaParametro-DivEquivalencias-labelError">Debe completar todos los campos.</label>
                            </div>
                        }
                        {equi.errorCodigoRepetido &&
                            <div className="col-xs-12">
                                <label className="error NuevaInstanciaParametro-DivEquivalencias-labelError">No se permite ingresar más de una instancia para el mismo código de equivalencia <strong>{codigoEquivalenciaSeleccionada}</strong>.</label>
                            </div>
                        }
                        {equi.errorSubequivalenciaRepetida &&
                            <div className="col-xs-12">
                                <label className="error NuevaInstanciaParametro-DivEquivalencias-labelError">No se permite seleccionar la misma sub-equivalencia <strong>{equi.CodigoSubequivalencia}</strong> para la misma equivalencia <strong>{codigoEquivalenciaSeleccionada}</strong>.</label>
                            </div>
                        }
                    </div>
                </div>
            )
        });


        if (permiteEquivalencia) {
            return (
                <div className="row top-separator-xs" >
                    <div className="col-xs-12" >
                        <h2>Equivalencias</h2>
                        {instanciaEquivalencias}
                        <div className="row bottom-separator-xs">
                            <div className="col-xs-12">
                                <a className="btn-link-atlas clickable agregar-equivalencia-btn" onClick={this.props.agregarEquivalencia}>Agregar equivalencia</a>
                            </div>
                        </div>
                    </div >
                </div >
            );
        } else {
            return (
                <div className="row top-separator-xs" >
                    {null}
                </div >
            );
        }

    }



}

export default Equivalencias